import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ApiService } from 'src/app/api/api.service';
import * as dayjs from 'dayjs';
import * as dayjsLocal from 'dayjs/plugin/localizedFormat';
import { AlertController, ModalController } from '@ionic/angular';
import { AutomaticStepTypes, ClientStepTypes, StepTypes } from '../../components/steps/StepTypes';
import { GlobalService } from 'src/app/api/global.service';
import { StepTypes as stepTypeEnum } from '../../components/steps/StepTypes';
import { AlignStepDueDateToTask, ApplyUseProjectDates, CalculateRelativeTaskDates, SetUseProjectDatesOffsets, TaskDueDateLabel, TaskStartDateLabel, UsesProjectDates } from '../../services/task-project-dates.util';
import { TASK_MEMBER_PLACEHOLDER, TaskMemberOptionsCache } from '../../services/task-assignment.util';

import { CreatePage as SurveyCreatePage } from '../../surveys/create/create.page';
import { SelectPage as SurveySelectPage } from '../../surveys/select/select.page';
import { SelectComponent as SkillsSelectPage } from 'src/app/components/tags/select/select.component';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { ExplorerComponent } from 'src/app/components/files/explorer/explorer.component';
import { SelectPage as TeamMemberSelectPage } from 'src/app/team-members/select/select.page';
import { EmailPreviewComponent } from '../../components/email-preview/email-preview.component';

@Component({
  selector: 'app-create',
  templateUrl: './create.page.html',
  styleUrls: ['./create.page.scss'],
})
export class CreatePage implements OnInit {
  stepTypeEnum = stepTypeEnum;
  items: MenuItem[];
  activeIndex: number = 0;
  automaticStepTypes = AutomaticStepTypes;
  require_roles = false;
  require_specific = false;
  save_as_template = false;
  @Input() edit_mode = false;
  @Input() create_edit_mode = false;
  // From project create: the team members who can access every client/company the project is for (only
  // they can be given this task). null = not known here, so nobody is ruled out.
  @Input() assignable_member_guids: Set<string> | null = null;
  TASK_MEMBER_PLACEHOLDER = TASK_MEMBER_PLACEHOLDER;
  private task_member_options_cache = new TaskMemberOptionsCache();
  possible_team_members: any = [];
  @Input() project: any = {
    "internal_start_date": "2023-01-07T04:00:00Z",
    "internal_end_date": "2023-01-20T04:00:00Z"
  }
  step: any = {
    "guid":"",
    "title": "",
    "description": "",
    "type": null, // No default - the user must pick an action type (see ValidStep)
    "is_internal": false,
    "company": {},
    "client": {},
    "status": "0",
    "due_date": "",
    "relative_date": true,
    "auto_start": false,
    // "auto_start_instant": true,
    // "auto_start_days_before": 0,
    // "auto_start_date": "",
    "due_date_relative": 0,
    "data": {
      webhook_method: 'POST',
      use_cert: true,
      // New actions remind automatically, on the firm's default reminder schedule
      auto_remind: true,
      use_firm_days_between: true,
      // New actions don't start automatically, so emails are reviewed before sending (see AutoStartChange)
      review_before_sending: true,
    }
  }
  current_edit_step: any = null;
  original_step_copy: any = null;
  @Input() edit_template_mode = false;
  @Input() task: any = {
    "guid": "",
    "title": "",
    "description": "",
    "status": "0",
    "company": {},
    "client": {},
    "is_internal": false,
    "due_date": "",
    "start_date": "",
    // New tasks run from the project's start date to its end date by default (see ApplyUseProjectDates)
    "use_project_dates": true,
    "relative_date": true,
    "relative_to_start": true,
    "due_date_relative": 3,
    "start_date_relative": 0,
    "start_date_relative_unit": "days",
    "due_date_relative_unit": "days",
    "type": 0,
    "force_order": true,
    "steps": [],
    "role": null,
    billing_rate: '',
    new_task: true,
    skills: [],
    require_specific: false,
    require_roles: false,
    assignment_settings: 0, //0=unassigned, 1=claim, 2=auto-assign
    assigned_member_guid: '',
    estimated_hours: 0,
    estimated_mins: 0,
    estimated_time: 0
  }

  taskInternalStatuses: any[] = [];
  loaded_internal_statuses = false;
  appointment_team_members_valid = true;
  appointment_calendar_setup_warnings: string[] = [];
  private calendarSetupCache: Record<string, boolean> = {};

  //Email templates
  email_templates: any = [];
  selected_template = '0';
  today = dayjs();
  billing_rates: any = [];
  selected_billing_rate: any;

  @ViewChild('bodyEditor') bodyEditor: any;
    private lastCursorIndex: number | null = null;

  client_roles: any = [];
  constructor(private modalController: ModalController, public globalService: GlobalService, private apiService: ApiService, private alertController: AlertController) {
    dayjs.extend(dayjsLocal);



  }



  // Adding a brand new task (vs updating one): project create opens both with create_edit_mode, but a task
  // that's already been added has a guid (Create() gives it one) and a new one doesn't yet.
  is_new_task = false;

  ngOnInit() {
    this.is_new_task = !this.edit_mode && !this.task?.guid;
    this.FormatData();
  }
  async FormatData() {
    this.ResetStepForm();
    this.GetTaskInternalStatuses();
    if (!this.task.skills) this.task.skills = [];
    if (!this.edit_mode) {
      if (this.task.assigned_member_guid == null) this.task.assigned_member_guid = '';
      // A task given its own team member (project create's task list allows it whatever the project's
      // Task Assignment is) keeps it - otherwise it follows the project.
      this.task.assignment_settings = this.task.assigned_member_guid ? 2 : (this.project.assignment_settings ?? 0);
    } else {
      if (this.task.assignment_settings == null) this.task.assignment_settings = 0;
      if (this.task.assigned_member_guid == null) this.task.assigned_member_guid = '';
    }
    if (this.task.estimated_time == null) {
      this.task.estimated_time = 0;
    }
    // estimated_time (raw minutes) is the actual source of truth used everywhere else -
    // estimated_hours/estimated_mins only exist to drive these two input boxes, and the backend
    // returns them as real persisted 0s (not null) rather than keeping them in sync with
    // estimated_time. Always derive them from estimated_time here instead of trusting whatever
    // the task already has, otherwise a loaded task's stored 0/0 silently wins over a correct,
    // non-zero estimated_time.
    this.task.estimated_hours = Math.floor(this.task.estimated_time / 60);
    this.task.estimated_mins = this.task.estimated_time % 60;
    if (this.edit_mode) {
      this.project.internal_end_date = dayjs(this.project.internal_end_date).format('YYYY-MM-DD');
      this.project.internal_start_date = dayjs(this.project.internal_start_date).format('YYYY-MM-DD');
      this.task.due_date = dayjs(this.task.due_date).format('YYYY-MM-DD');
      this.task.start_date = dayjs(this.task.start_date).format('YYYY-MM-DD');
      for (let i = 0; i < this.task.steps.length; i++) {
        const step = this.task.steps[i];
        step.due_date = dayjs(step.due_date).format('YYYY-MM-DD');
        console.log("Edit mode step", step);
        if (!step.data) {
          if (step.steps_data?.length) {
            try { step.data = JSON.parse(step.steps_data[0].step_data); } catch { step.data = {}; }
          } else {
            //Get each step with an API request so we know the data
            let data: any = await this.apiService.get(`steps/${step.guid}`);
            if(data.success) {
              step.data = JSON.parse(data.data[0].steps_data[0].step_data);
            }
            else step.data = {};
            console.log("Step data", step.data);

            
          }
        }
      }
    }
    this.task.steps?.forEach((step: any) => {
      if (step.data?.surveys?.length) {
        step.data.surveys = this.normalizeSurveys(step.data.surveys);
      }
    });
    

    if (this.project.is_internal) {
      this.task.is_internal = true;
      this.step.is_internal = true;
    }
    else if (!this.edit_mode) {
      // Worked out when the task is created (see IsTaskInternal) - until then it stays open to client
      // actions, including when re-editing a task that was already marked internal that way.
      this.task.is_internal = false;
    }
    if (this.project.all_team_members) {
      this.GetTeamMembers();
    }
    else {
      this.possible_team_members = this.project.team_members;
    }
    this.items = [
      { label: 'Task Setup' },
      { label: 'Add Actions' },
      { label: 'Review' }
    ];
    // An existing task saved with "Use project dates" may only have kept the offsets that stand for it
    if (UsesProjectDates(this.task)) this.task.use_project_dates = true;
    this.CalculateDueDate();
    this.GetClientRoles();
    this.GetEmailTemplates();
    this.GetBillingRates();
    this.LoadAllSkills();
    if (this.edit_template_mode) {
      //Loop through and set the step dates to be the right days
      this.task.steps.forEach(step => {
        if (step.relative_date) {
          step.due_date = dayjs(this.task.start_date).add(step.due_date_relative, 'day').format('YYYY-MM-DD');
        }
      });
    }
  }

  async GetEmailTemplates() {
    let data: any = await this.apiService.get('email_templates');
    this.email_templates = data.data;
  }

  async GetTeamMemberDetails() {
    for (let member of this.possible_team_members) {
      if (!member.skills) {
        let data: any = await this.apiService.get(`team_members/${member.guid}`);
        if (data.success) {
          const memberIndex = this.possible_team_members.findIndex(m => m.guid === member.guid);
          if (memberIndex !== -1) {
            this.possible_team_members[memberIndex] = data.data;
          }
        }
      }
    }
  }

  //Email template
  async EmailTemplateChange() {
    this.step.data.body = '';
    var selected_template = this.email_templates.find(template => template.guid == this.selected_template);
    if (selected_template) this.step.data.body = selected_template.body;

  }

  async GetTaskInternalStatuses() {
    this.loaded_internal_statuses = false;
    const data: any = await this.apiService.get('tags/tasks_internal_status');
    if (data.success) this.taskInternalStatuses = data.data || [];
    if(!this.taskInternalStatuses) this.taskInternalStatuses = [];
    this.loaded_internal_statuses = true;
  }

  get taskInternalStatusOptions() {
    return [
      { value: '', label: 'None', description: 'No internal status set.' },
      ...this.taskInternalStatuses.map(s => ({ value: s.guid, label: s.title, description: s.description, color: s.colour }))
    ];
  }

  GetInternalStatusByGuid(guid: string) {
    if (!guid || !this.taskInternalStatuses?.length) return null;
    return this.taskInternalStatuses.find(s => s.guid === guid) || null;
  }

  async GetBillingRates() {
    let data: any = await this.apiService.get('billing/rates');
    if (data.success) {
      this.billing_rates = data.data;
    }
  }

  SetDefaultTeamMember() {
    if (this.task.assigned_member_guid == '') this.task.assigned_member_guid = this.possible_team_members[0]?.guid;
  }
  async GetTeamMembers() {
    let data: any = await this.apiService.get('team_members');
    if (data.success) {
      this.possible_team_members = data.data;
    }
  }

  async selectedBillingRate() {
    this.task.default_billing_rate = this.selected_billing_rate.guid;
  }

  async GetClientRoles() {
    let data: any = await this.apiService.GetRoles();
    if (data.success) this.client_roles = data.data;
  }

  isClientStepType(): boolean {
    return ClientStepTypes.includes(Number(this.step?.type));
  }

  getAvailableOverrideRoles(): any[] {
    return this.client_roles || [];
  }

  private getProjectMinRoleLevel(): number | null {
    const companiesWithRoles = (this.project?.assigned_companies || [])
      .filter((c: any) => c.role_guid && c.role_level != null);
    if (companiesWithRoles.length) {
      return Math.min(...companiesWithRoles.map((c: any) => Number(c.role_level)));
    }
    if (this.project?.role_guid && this.client_roles?.length) {
      const projectRole = this.client_roles.find((r: any) => r.guid === this.project.role_guid);
      if (projectRole?.level != null) return Number(projectRole.level);
    }
    return null;
  }

  isOverrideRoleDisabled(role: any): boolean {
    const minLevel = this.getProjectMinRoleLevel();
    if (minLevel === null) return false;
    return role.level != null && Number(role.level) > minLevel;
  }

  hasDisabledOverrideRoles(): boolean {
    return (this.client_roles || []).some((r: any) => this.isOverrideRoleDisabled(r));
  }

  GoToStep(step) {
    this.activeIndex = step;
  }

  // How the Review step shows the task's dates: a one-off project has real dates, so show them; a repeating
  // project's dates change every time, so show how they're worked out instead ("On project start",
  // "3 days after project start", ...).
  ReviewDateLabel(which: 'start' | 'due'): string {
    const exact = which === 'start' ? this.task.start_date : this.task.due_date;
    if (!this.project.repeat) return exact || '—';
    if (this.task.relative_date || UsesProjectDates(this.task)) {
      return which === 'start' ? TaskStartDateLabel(this.task) : TaskDueDateLabel(this.task);
    }
    return exact || '—';
  }

  // "Use project dates" on: the offsets are set to stand for it and the dates follow the project. Off: the
  // offsets go back to the usual defaults for the team member to adjust.
  UseProjectDatesChange() {
    if (!this.task.use_project_dates) {
      this.task.relative_to_start = true;
      this.task.start_date_relative = 0;
      this.task.start_date_relative_unit = 'days';
      this.task.due_date_relative = 3;
      this.task.due_date_relative_unit = 'days';
    }
    this.CalculateDueDate();
  }

  CalculateDueDate() {
    if (this.edit_mode) return;
    if (this.task.use_project_dates) {
      SetUseProjectDatesOffsets(this.task);
    }
    CalculateRelativeTaskDates(this.task, this.project.internal_start_date, this.project.internal_end_date);
    this.CalculateDueDateStep();
    this.SyncStepDueDates();
  }

  GetTaskDueDateInDays(): number {
    if (!this.task.due_date || !this.task.start_date) return 0;
    return Math.max(0, dayjs(this.task.due_date).diff(dayjs(this.task.start_date), 'day'));
  }

  // Actions are always due on their task's due date - there's no per-action due date option.
  // SetStepDueDateToTask keeps relative_date / due_date_relative populated so the JSON still
  // carries the same fields the backend and templates expect.
  SetStepDueDateToTask(step: any) {
    AlignStepDueDateToTask(this.task, step);
  }

  // Re-applies the task due date to every action already added, so they follow task date changes.
  SyncStepDueDates() {
    (this.task.steps || []).forEach(step => this.SetStepDueDateToTask(step));
  }

  CalculateDueDateStep() {
    this.SetStepDueDateToTask(this.step);
  }

  // Groups the action types in the dropdown: Team actions are done by the team, Client actions reach the client and System
  // actions run on their own. Portal access emails the client their login and runs automatically, so it is listed under both
  // Client and System.
  readonly actionTypeCategories = [
    { key: 'team', label: 'Team', icon: 'fa-solid fa-users', description: 'Actions your team completes internally.' },
    { key: 'client', label: 'Client', icon: 'fa-solid fa-user', description: 'Actions that reach out to the client.' },
    { key: 'system', label: 'System', icon: 'fa-solid fa-gear', description: 'Actions that modify the system.' },
  ];

  get actionTypeOptions() {
    const clientDisabled = !!(this.task?.is_internal || this.step?.is_internal);
    return [
      { value: stepTypeEnum.checkbox, category: 'team',               label: 'Required Action',                 icon: 'fa-regular fa-square-check', description: 'A required action that a team member marks as complete.' },
      { value: stepTypeEnum.checklist, category: 'team',              label: 'Checklist',                       icon: 'fa-solid fa-list-check',      description: "This action item allows you to create a list of items your team checks off as they work.  This is an ideal way to create an internal standard operating procedures series of checkmarks for your team members" },
      { value: stepTypeEnum.activate_client_portal, category: ['client', 'system'],  label: 'Give Client Portal Access',        icon: 'fa-solid fa-door-open',       description: 'Grants the client access to the client portal.' },
      { value: stepTypeEnum.standard_operating_procedure, category: 'team', label: 'Standard Operating Procedure Attached Document', icon: 'fa-solid fa-book',            description: "This action item allows you to attach an external Standard Operating Procedure document like a PDF or an Excel Spreadsheet for your staff to reference when completing this task.  Note: The above 'Checklist' action item is the ideal way to create an internal checklist" },
      { value: stepTypeEnum.conditional, category: 'team',             label: 'If / Then',                        icon: 'fa-solid fa-code-branch',     description: 'Branching logic — follow different paths based on a condition.' },
      { value: stepTypeEnum.upload_file, category: 'team',             label: 'Upload File',                       icon: 'fa-solid fa-upload',          description: 'A step where a file is uploaded or attached by a team member.' },
      // { value: stepTypeEnum.important_file_upload, category: ['team', 'client'], label: 'Important File Upload',   icon: 'fa-solid fa-cloud-arrow-up',  description: 'Same as Upload File, but every file uploaded is automatically marked important and made visible to the client. Can optionally request specific named files up front, same as a Document Request.' },
      { value: stepTypeEnum.email, category: 'client',                   label: 'Send Secure Email',                 icon: 'fa-solid fa-envelope',        description: 'Sends a secure email to the client.', isClientAction: true, disabled: clientDisabled },
      { value: stepTypeEnum.document_request, category: 'client',        label: 'Send Secure Document Request',      icon: 'fa-solid fa-file-arrow-up',   description: 'Requests the client to upload documents securely.', isClientAction: true, disabled: clientDisabled },
      { value: stepTypeEnum.signature_request, category: 'client',       label: 'Send Client Signature Request',     icon: 'fa-solid fa-pen-nib',         description: 'Sends a document to the client for electronic signature.', isClientAction: true, disabled: clientDisabled },
      { value: stepTypeEnum.approval_request, category: 'client',        label: 'Send Client Approval Request',      icon: 'fa-solid fa-thumbs-up',       description: 'Requests the client to approve or reject something.', isClientAction: true, disabled: clientDisabled },
      { value: stepTypeEnum.question_request, category: 'client',        label: 'Send Client Question Request',      icon: 'fa-solid fa-circle-question', description: 'Asks the client a question they answer securely, optionally with a signature.', isClientAction: true, disabled: clientDisabled },
      { value: stepTypeEnum.checklist_request, category: 'client',       label: 'Send Client Checklist Request',     icon: 'fa-solid fa-list-check',      description: 'Sends the client a checklist to work through - they check off each item, then mark it as completed.', isClientAction: true, disabled: clientDisabled },
      { value: stepTypeEnum.survey, category: 'client',                  label: 'Send Client Form Request',         icon: 'fa-solid fa-clipboard-list',  description: 'Sends a form or survey for the client to fill out.', isClientAction: true, disabled: clientDisabled },
      { value: stepTypeEnum.appointment_request, category: 'client',     label: 'Send Client Appointment Request',   icon: 'fa-solid fa-calendar-plus',   description: 'Allows the client to schedule an appointment.', isClientAction: true, disabled: clientDisabled },
      { value: stepTypeEnum.payment_request, category: 'client',         label: 'Send Payment Request',              icon: 'fa-solid fa-credit-card',     description: 'Sends an invoice or payment request to the client.', isClientAction: true, disabled: clientDisabled },
      { value: stepTypeEnum.webhook, category: 'system',                 label: 'Webhook',                           icon: 'fa-solid fa-plug',            description: 'Triggers an HTTP call to an external service.' },
    ];
  }

  ShowDateLocal(date) {
    return dayjs(date).format('L');
  }
  // ---- Checklist action: the starting items, saved with the action as step.data.items ----
  new_checklist_item = '';
  new_checklist_description = '';

  AddChecklistItem() {
    const text = (this.new_checklist_item || '').trim();
    if (!text) return;
    if (!Array.isArray(this.step.data.items)) this.step.data.items = [];
    const description = (this.new_checklist_description || '').trim();
    this.step.data.items.push({
      guid: (typeof crypto !== 'undefined' && (crypto as any).randomUUID) ? (crypto as any).randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2),
      text,
      ...(description ? { description } : {}),
      checked: false
    });
    this.new_checklist_item = '';
    this.new_checklist_description = '';
  }

  RemoveChecklistItem(item: any) {
    const index = this.step.data.items.indexOf(item);
    if (index !== -1) this.step.data.items.splice(index, 1);
  }

  async TypeChange() {
    if (Number(this.step.type) === stepTypeEnum.checklist || Number(this.step.type) === stepTypeEnum.checklist_request) {
      if (!Array.isArray(this.step.data.items)) this.step.data.items = [];
    }
    if (Number(this.step.type) === stepTypeEnum.question_request) {
      if (this.step.data.question === undefined) this.step.data.question = '';
      if (this.step.data.require_signature === undefined) this.step.data.require_signature = false;
    }
    if (this.step.type == stepTypeEnum.payment_request) { this.step.data.payment_type = 0; }
    // Defaults true only here (new steps being created) - the backend treats a step saved without
    // this field at all (existing older Upload File steps) as false, so it never silently changes
    // behavior for steps that predate this option.
    if (Number(this.step.type) === stepTypeEnum.upload_file) {
      if (this.step.data.mark_files_important === undefined) this.step.data.mark_files_important = true;
    }
    if (Number(this.step.type) === stepTypeEnum.appointment_request) {
      if (this.step.data.any_team_member === undefined) this.step.data.any_team_member = true;
      if (!this.step.data.allowed_team_members) {
        this.step.data.allowed_team_members = [];
        const currentUser = this.globalService.GetCurrentUser();
        if (currentUser) this.step.data.allowed_team_members = [{ ...currentUser }];
      }
      this.CheckAppointmentCalendarSetups();
    }
    if (Number(this.step.type) === stepTypeEnum.conditional) {
      this.step.auto_start = false;
      if (!this.step.data.options) this.step.data.options = [];
      if (this.step.data.options.length === 0) {
        this.AddConditionalOption();
        this.AddConditionalOption();
      }
      this.normalizeConditionalOptions(this.step.data.options);
    }
    if (!this.isAutomaticStep()) this.step.auto_start = false;
  }


  ValidStep() {
    let error_message = '';
    if (this.step.type === null || this.step.type === undefined || this.step.type === '') {
      error_message += 'Action type must be selected. ';
    }
    if (!this.step.title || this.step.title.trim() === '') {
      error_message += 'Action title must be set. ';


    }
    if (!this.IsAutoStartDateValid()) {
      error_message += 'Auto start date must be after project start date.';
    }

    const emailTypes = [
      stepTypeEnum.email,
      stepTypeEnum.document_request,
      stepTypeEnum.payment_request,
      stepTypeEnum.survey,
      stepTypeEnum.appointment_request
    ];
    if (emailTypes.includes(Number(this.step.type))) {
      if (!this.step.data.subject || this.step.data.subject.trim() === '') {
        error_message += 'Subject is required for this action. ';
      }
      if (!this.step.data.body || this.step.data.body.trim() === '') {
        error_message += 'Body is required for this action. ';
      }
    }
    if (Number(this.step.type) === stepTypeEnum.question_request) {
      if (!this.step.data.subject || this.step.data.subject.trim() === '') {
        error_message += 'Subject is required for this action. ';
      }
      if (!this.hasRichTextContent(this.step.data.question)) {
        error_message += 'A question is required for this action. ';
      }
    }
    if (Number(this.step.type) === stepTypeEnum.checklist_request) {
      if (!this.step.data.subject || this.step.data.subject.trim() === '') {
        error_message += 'Subject is required for this action. ';
      }
      if (!(this.step.data.items || []).some((item: any) => (item?.text || '').trim())) {
        error_message += 'Add at least one checklist item for the client. ';
      }
    }
    if (Number(this.step.type) === stepTypeEnum.appointment_request) {
      if (!this.step.data.any_team_member &&
          (!this.step.data.allowed_team_members || this.step.data.allowed_team_members.length === 0)) {
        error_message += 'Please select at least one team member, or allow booking with any team member. ';
      }
      if (!this.appointment_team_members_valid) {
        error_message += 'One or more selected team members do not have permission to access the project client(s). ';
      }
    }
    if (Number(this.step.type) === stepTypeEnum.payment_request && Number(this.step.data.payment_type) === 0) {
      if (!this.step.data.payment_request_amount || Number(this.step.data.payment_request_amount) <= 0) {
        error_message += 'Payment request amount must be greater than zero. ';
      }
    }
    if (Number(this.step.type) === stepTypeEnum.conditional) {
      const opts = this.step.data.options || [];
      if (opts.length < 2) {
        error_message += 'A conditional action must have at least 2 options. ';
      } else {
        if (opts.some(o => !o.label || o.label.trim() === '')) {
          error_message += 'All conditional options must have a label. ';
        }
        if (opts.some(o => !this.hasRichTextContent(o.pre_choice_description))) {
          error_message += 'All conditional options must have pre-choice description content. ';
        }
        if (opts.some(o => !this.hasRichTextContent(o.post_choice_instructions))) {
          error_message += 'All conditional options must have post-choice instructions content. ';
        }
      }
    }

    if (ClientStepTypes.includes(Number(this.step.type)) &&
        this.step.data?.send_to_different_role &&
        this.step.data?.override_role_guid &&
        !this.project?.create_template) {
          console.log("~~~~~~~~~~~~~~~~~~~~~");
          console.log("Checking for default contact for override role", this.step.data.override_role_guid);
      const overrideRoleGuid = this.step.data.override_role_guid;
      const companies: any[] = this.project?.assigned_companies || [];
      for (const company of companies) {
        console.log("Checking company for default contact", company);
        const clients: any[] = company.clients || [];
        const hasDefault = clients.some((c: any) =>
          c.role_guid === overrideRoleGuid && c.is_default_for_role
        );
        if (!hasDefault) {
          error_message += `<br>"${company.name}" has no default contact set for the selected "Send to Different Role" role. Set one in the company before adding this action.<br>`;
        }
      }
    }

    return error_message;
  }
  UpdateStep() {
    this.CalculateDueDateStep();

    // Find and update the step in the array
    const stepIndex = this.task.steps.findIndex(s => s.guid === this.current_edit_step.guid);
    if (stepIndex !== -1) {
      this.task.steps[stepIndex] = JSON.parse(JSON.stringify(this.step));
      console.log("Updated step", this.task.steps[stepIndex]); 
      this.globalService.presentToastMessage('Action updated successfully.', true);
      this.ResetStepForm();
      this.current_edit_step = null;
      this.original_step_copy = null;
    }
  }
  AddStep() {
    // Prevent adding a step if currently in edit mode
    if (this.current_edit_step) {
      this.globalService.presentToastMessage('Please finish editing the current action first.', false);
      return;
    }

    this.CalculateDueDateStep();

    this.step.company = this.task.company;
    this.step.client = this.task.client;
    this.step.guid = this.globalService.createGUID();
    this.step.status = '0';
    this.task.steps.push(JSON.parse(JSON.stringify(this.step)));
    this.ResetStepForm();
  }

  async RemoveStep(step) {
    const alert = await this.alertController.create({
      header: 'Remove Action',
      message: 'Are you sure you want to remove this action? ' + step.title,
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        {
          text: 'Remove',
          handler: () => {
            const index = this.task.steps.findIndex(obj =>
              JSON.stringify(obj) === JSON.stringify(step)
            );
            if (index !== -1)
              this.task.steps.splice(index, 1);
          }
        }
      ]
    });
    await alert.present();
  }

  async OpenEmailPreview(step: any) {
    const modal = await this.modalController.create({
      component: EmailPreviewComponent,
      cssClass: 'large-modal',
      backdropDismiss: true,
      componentProps: {
        type: step.type,
        subject: step.data?.subject || '',
        description: step.data?.description || '',
        body: step.data?.body || '',
        contact: this.project?.assigned_clients?.[0] || null,
        company: this.project?.assigned_companies?.[0] || null,
        project: this.project || null,
        task: this.task || null,
        action: step || null,
      }
    });
    return await modal.present();
  }

  async Close() {
    const isDirty = this.task.title?.trim() || this.task.steps?.length > 0;
    if (isDirty) {
      const alert = await this.alertController.create({
        header: 'Are you sure?',
        message: 'You have unsaved changes. If you cancel now, your work will be lost.',
        buttons: [
          { text: 'Keep Editing', role: 'cancel' },
          { text: 'Discard', role: 'destructive', handler: () => this.modalController.dismiss(null) }
        ]
      });
      await alert.present();
    } else {
      this.modalController.dismiss(null);
    }
  }

  // Client actions are the ones in the action type dropdown's Client category (they reach the client).
  HasClientActions(): boolean {
    const clientTypes = this.actionTypeOptions
      .filter((o: any) => ([] as string[]).concat(o.category).includes('client'))
      .map((o: any) => Number(o.value));
    return (this.task.steps || []).some((s: any) => clientTypes.includes(Number(s.type)));
  }

  // There's no Internal Task checkbox - an internal project's tasks are always internal, and otherwise a
  // task is internal when it has no client actions. An existing task keeps what it was saved with.
  IsTaskInternal(): boolean {
    if (this.edit_mode) return !!this.task.is_internal;
    return !!this.project.is_internal || !this.HasClientActions();
  }

  CanBeAssignedTask(member: any): boolean {
    return !this.assignable_member_guids || this.assignable_member_guids.has(member?.guid);
  }

  TaskAssigneeLacksAccess(): boolean {
    return !!this.task.assigned_member_guid && !this.CanBeAssignedTask({ guid: this.task.assigned_member_guid });
  }

  GetTaskMemberOptions() {
    return this.task_member_options_cache.Get(this.project.assignment_settings, this.possible_team_members, this.assignable_member_guids);
  }

  // A specific team member can be picked whatever the project's Task Assignment is - that task is then
  // "Specify Team Members" (2) on its own; without one it follows the project's setting.
  OnAssignedMemberChange() {
    this.task.assigned_member_guid = this.task.assigned_member_guid || '';
    this.task.assignment_settings = this.task.assigned_member_guid ? 2 : (this.project.assignment_settings ?? 0);
  }

  async Create() {
    this.task.is_internal = this.IsTaskInternal();
    this.OnAssignedMemberChange();
    //if(this.ValidTaskDate() != '') return;
    if (!this.edit_mode) {
      this.task.front_end_guid = this.globalService.createGUID();
      this.task.guid = this.globalService.createGUID();
    }
    // Task dates may have been edited since the actions were added (edit mode skips CalculateDueDate).
    this.SyncStepDueDates();
    //Return the times back to the proper format
    if (this.edit_mode) {
      this.task.due_date = dayjs(this.task.due_date).format('YYYY-MM-DD') + "T00:00:00";
      this.task.start_date = dayjs(this.task.start_date).format('YYYY-MM-DD') + "T00:00:00";
      this.task.steps.forEach(step => {
        step.due_date = dayjs(step.due_date).format('YYYY-MM-DD') + "T00:00:00";
      });
    }
    if (this.save_as_template) {
      let data: any = await this.apiService.post('templates/tasks', this.task);
      if (data.success) this.modalController.dismiss(this.task);
      this.globalService.presentToastMessage(data.message, data.success);
    }
    else {
      this.modalController.dismiss(this.task);
    }
  }

  async Save() {
    this.task.front_end_guid = this.globalService.createGUID();
    this.modalController.dismiss(this.task);
  }

  ValidTaskDetails() {
    let error_message = '';
    if (this.task.title == '') error_message += 'You must have a title for the task.\n';
    if (this.ValidTaskDate() != '') error_message += this.ValidTaskDate() + '\n';
    if (this.project.assignment_settings === 2 && !this.task.assigned_member_guid) {
      error_message += 'You must assign a team member to this task.\n';
    }
    if (this.TaskAssigneeLacksAccess()) {
      error_message += "The assigned team member doesn't have access to all clients this project is being created for.\n";
    }
    return error_message;
  }

  ValidTaskDate() {
    let error_message = '';

    if (new Date(this.task.due_date) > new Date(this.project.internal_end_date)) {
      error_message += 'Task due date must be on or before the project end date.     ';
    }
    if (new Date(this.task.start_date) < new Date(this.project.internal_start_date)) {
      error_message += 'Task start date must be on or after the project start date.     ';
    }
    if (new Date(this.task.start_date) > new Date(this.task.due_date)) {
      error_message += 'Task start date must be before or equal to the due date.';
    }
    return error_message;;
  }

  Log() {
    
  }

  async OpenSurveyCreate() {
    const modal = await this.modalController.create({
      component: SurveyCreatePage,
      componentProps: {

      },
      backdropDismiss: true,
      cssClass: 'large-modal'
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
    if (data) {
      if (data != null) {
        if (this.step.data == null || this.step.data.surveys == null) {
          this.step.data.surveys = [];
        }
        this.step.data.surveys.push(data);
      }
    }
  }


  async OpenSurveySelect() {
    const modal = await this.modalController.create({
      component: SurveySelectPage,
      componentProps: {

      },
      backdropDismiss: true,
      cssClass: 'large-modal'
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
    if (data) {
      if (data != null) {
        if (this.step.data == null || this.step.data.surveys == null) {
          this.step.data.surveys = [];
        }
        this.step.data.surveys.push(...data);
      }
    }
  }

  async RemoveSurvey(survey) {
    console.log(survey);
    this.globalService.RemoveFromArray(this.step.data.surveys, survey.guid);
  }

  // "Review before sending" (client actions that send an email) and Automatically Start can't both be on - an automatic start has no one to
  // review the email, so turning either on turns the other off.
  ReviewBeforeSendingChange() {
    if (this.step.data?.review_before_sending) this.step.auto_start = false;
  }

  // Automatically Start off means someone starts the action by hand, so the email defaults back to being
  // reviewed before it's sent (still just a default - they can untick it).
  AutoStartChange() {
    if (!this.step.data) return;
    this.step.data.review_before_sending = !this.step.auto_start;
  }

  isAutomaticStep() {
    return this.automaticStepTypes.includes(Number(this.step.type));
  }

  // Review before sending only applies to (and is only shown for) client actions that send an email, so a
  // value left over from a previous type doesn't lock Automatically Start on a type that can't show it.
  ReviewBlocksAutoStart(): boolean {
    return ClientStepTypes.includes(Number(this.step.type)) && !!this.step.data?.review_before_sending;
  }

  // Tooltip on Automatically Start - why it's disabled, or a warning about it ('' shows nothing).
  AutoStartTooltip(): string {
    if (!this.isAutomaticStep()) return 'Disabled because this action type cannot start automatically.';
    if (this.ReviewBlocksAutoStart()) return 'Disabled because Review before sending is on - an automatic start has no one to review the email before it is sent.';
    if (this.task.steps.length == 0) return 'The first action in a task cannot be automatic';
    return '';
  }

  async AddFileRequest() {
    if (!this.step.data.specific_files) this.step.data.specific_files = [];
    // Make sure AlertController is imported and injected in the constructor
    // constructor(private modalController: ModalController, private alertController: AlertController, ...)
    const alert = await this.alertController.create({
      backdropDismiss: false,
      header: 'Add File Request',
      inputs: [
        {
          name: 'name',
          type: 'text',
          placeholder: 'File Name'
        },
        {
          name: 'description',
          type: 'text',
          placeholder: 'Description'
        }
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'Add',
          handler: (data) => {
            if (!data.name) {
              this.globalService.presentToastMessage('A name is required.', false);
              return false;
            }
            this.step.data.specific_files.push({ name: data.name, description: data.description || '' });
          }
        }
      ]
    });
    await alert.present();
  }
  async RemoveSpecificFile(name) {
    const index = this.step.data.specific_files.findIndex(file => file.name === name);
    if (index !== -1) {
      this.step.data.specific_files.splice(index, 1);
    }
  }

  CheckIfTaskValid() {
    let error_message = '';
    if (this.task.steps.length == 0) error_message += 'You must have at least one action in the task.\n';
    if (!this.task.title || this.task.title.length <= 0) error_message += 'You must have a title for the task.\n';
    // if(this.HasProjectDateConflict()) error_message += 'You have a date conflict with the project dates.\n';

    if (this.task.is_internal) {
      // Check if any step in any task is a client step type
      for (const step of this.task.steps) {
        if (ClientStepTypes.includes(Number(step.type))) {
          error_message += 'This task cannot be internal as it has actions that require client access.\n';
          break;
        }
      }
    }

    return error_message;
  }

  async presentSelectSkillsModal() {
    let skills_copy = JSON.stringify(this.task.skills);
    const modal = await this.modalController.create({
      component: SkillsSelectPage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        url: 'team_members',
        selected_tags: this.task.skills,
        title: "Select Skills",
        source_header: "Avaliable Skills",
        target_header: "Assigned Skills",
        name: "Skill"
      }
    })
    modal.onDidDismiss().then((data: any) => {

      if (data && data.data) {
        skills_copy = JSON.parse(skills_copy);
      }
      else {
        this.task.skills = [...JSON.parse(skills_copy)];
      }
      // New skills can be created in that modal, so don't keep offering a stale list
      this.apiService.ClearCached(this.SKILLS_URL);
      this.LoadAllSkills();
    });
    return await modal.present()
  }

  async RemoveSkill(skill) {
    this.globalService.RemoveFromArray(this.task.skills, skill.guid);
  }

  // ---- Skills: type to search, same as the project Tags input ----
  // Skills are the team_members tags. Cached for a few minutes (ApiService.GetCached) so creating several
  // tasks in a row doesn't reload them every time.
  private readonly SKILLS_URL = 'tags/team_members';
  all_skills: any[] = [];
  skill_search_query = '';
  skill_suggestions: any[] = [];
  skill_suggestions_active_index = -1;
  show_skill_suggestions = false;

  async LoadAllSkills() {
    const data: any = await this.apiService.GetCached(this.SKILLS_URL);
    this.all_skills = data?.success && Array.isArray(data.data) ? data.data : [];
  }

  OnSkillSearchChange() {
    const q = (this.skill_search_query || '').trim().toLowerCase();
    this.skill_suggestions_active_index = -1;
    if (!q || !this.all_skills.length) {
      this.skill_suggestions = [];
      this.show_skill_suggestions = false;
      return;
    }
    const selectedGuids = new Set((this.task.skills || []).map((s: any) => s.guid));
    this.skill_suggestions = this.all_skills
      .filter((s: any) => !selectedGuids.has(s.guid) && (s.title || '').toLowerCase().includes(q))
      .slice(0, 15);
    this.show_skill_suggestions = this.skill_suggestions.length > 0;
  }

  OnSkillInputFocus() {
    if (this.skill_search_query) this.OnSkillSearchChange();
  }

  OnSkillInputBlur() {
    this.show_skill_suggestions = false;
  }

  OnSkillInputKeydown(event: KeyboardEvent) {
    if (!this.show_skill_suggestions || this.skill_suggestions.length === 0) return;
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.skill_suggestions_active_index = Math.min(this.skill_suggestions_active_index + 1, this.skill_suggestions.length - 1);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.skill_suggestions_active_index = Math.max(this.skill_suggestions_active_index - 1, 0);
    } else if (event.key === 'Enter') {
      event.preventDefault();
      const index = this.skill_suggestions_active_index >= 0 ? this.skill_suggestions_active_index : 0;
      this.SelectSkillSuggestion(this.skill_suggestions[index]);
    } else if (event.key === 'Escape') {
      this.show_skill_suggestions = false;
    }
  }

  SelectSkillSuggestion(skill: any) {
    if (skill?.guid && !(this.task.skills || []).some((s: any) => s.guid === skill.guid)) {
      this.task.skills = [...(this.task.skills || []), skill];
    }
    this.skill_search_query = '';
    this.skill_suggestions = [];
    this.skill_suggestions_active_index = -1;
    this.show_skill_suggestions = false;
  }

  AddConditionalOption() {
    if (!this.step.data.options) this.step.data.options = [];
    this.step.data.options.push({
      label: '',
      pre_choice_description: '',
      post_choice_instructions: ''
    });
  }

  RemoveConditionalOption(option: any) {
    const idx = this.step.data.options.indexOf(option);
    if (idx !== -1) this.step.data.options.splice(idx, 1);
  }

  async UpdateTemplate() {

  }

  IsAutoStartDateValid(): boolean {
    if (this.step.auto_start == false) return true;
    if (
      this.step.auto_start_days_before !== undefined &&
      this.step.auto_start_days_before !== null &&
      this.task.due_date &&
      this.project.internal_start_date
    ) {
      return !dayjs(this.step.auto_start_date).isBefore(dayjs(this.project.internal_start_date), 'day');
    }
    return true;
  }


  //File DROPZONE
  async dropped(files: NgxFileDropEntry[]) {
    if (this.step.data.file_list == null) this.step.data.file_list = [];
    for (const droppedFile of files) {
      // Is it a file?
      if (droppedFile.fileEntry.isFile) {

        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;

        await fileEntry.file(async (file: File) => {
          let file_guid = await this.apiService.UploadFile(file, '0',null);
          if (file_guid != null) {
            let push_data = {
              guid: file_guid,
              file_name: file.name,
            }
            this.step.data.file_list.push(push_data);
          }
        });
      } else {
        this.globalService.presentToastMessage('Only files are allowed', false);
      }
    }
  }

  async RemoveFile(file) {
    if (file.was_selected) this.globalService.RemoveFromArray(this.step.data.file_list, file.guid);
    else {
      let data: any = await this.apiService.delete(`files/${file.guid}`, null);
      this.globalService.presentToastMessage(data.message, data.success);
      if (data.success) {
        this.globalService.RemoveFromArray(this.step.data.file_list, file.guid);
      }
    }

  }

  async OpenFileSelect() {
    const modal = await this.modalController.create({
      component: ExplorerComponent,
      componentProps: {
        file_select_mode: true,
        root_folder_guid: '0'
      },
      backdropDismiss: true,
      cssClass: 'large-modal'
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
    if (data) {
      for (let i = 0; i < data.length; i++) {
        data[i].was_selected = true;
        this.step.data.file_list.push(data[i]);
      }
    }
  }

  async EditStep(step) {
    // Store original step data for potential rollback
    this.original_step_copy = JSON.parse(JSON.stringify(step));

    // Set the current step being edited
    this.current_edit_step = step;

    // Populate the form with the step data
    this.step = JSON.parse(JSON.stringify(step));
    if (!this.step.data) {
      if (this.step.steps_data?.length) {
        try { this.step.data = JSON.parse(this.step.steps_data[0].step_data); } catch { this.step.data = {}; }
      } else {
        this.step.data = { webhook_method: 'POST', use_cert: true };
      }
    }
    if (this.step.data?.surveys) {
      this.step.data.surveys = this.normalizeSurveys(this.step.data.surveys);
    }
    this.CalculateDueDateStep();
    if (Number(this.step.type) === stepTypeEnum.conditional) {
      if (!this.step.data) this.step.data = {};
      if (!this.step.data.options) this.step.data.options = [];
      this.normalizeConditionalOptions(this.step.data.options);
    }
  }

  // An action is set up in the form (or being edited) but hasn't been added/updated yet - moving on to
  // Review would silently lose it, so Next is blocked until it's added or cleared.
  HasPendingAction(): boolean {
    if (this.current_edit_step) return true;
    const s = this.step || {};
    return !!(s.title && String(s.title).trim()) ||
      !!(s.description && String(s.description).trim()) ||
      (s.type !== null && s.type !== undefined && s.type !== '');
  }

  // Throws away whatever is in the action form (or the edit in progress).
  ClearCurrentAction() {
    if (this.current_edit_step) this.CancelEdit();
    else this.ResetStepForm();
  }

  async ConfirmClearAction() {
    const alert = await this.alertController.create({
      header: 'Clear Action',
      message: 'Are you sure you want to clear this action? Everything you have set up for it will be lost.',
      buttons: [
        { text: 'Cancel', role: 'cancel' },
        { text: 'Clear', role: 'destructive', handler: () => this.ClearCurrentAction() }
      ]
    });
    await alert.present();
  }

  NextFromActionsTooltip(): string {
    if (this.task.steps.length == 0) return 'You must add at least one action.';
    if (this.current_edit_step) return 'Finish editing the current action first - click Update Action or Cancel Edit.';
    if (this.HasPendingAction()) return 'You have an action set up that has not been added yet - click Add Action, or Clear Action to discard it.';
    return '';
  }

  CancelEdit() {
    // Revert the step to its original state
    if (this.current_edit_step && this.original_step_copy) {
      const stepIndex = this.task.steps.findIndex(s => s.guid === this.current_edit_step.guid);
      if (stepIndex !== -1) {
        this.task.steps[stepIndex] = JSON.parse(JSON.stringify(this.original_step_copy));
      }
    }

    // Reset the form and editing state
    this.ResetStepForm();
    this.current_edit_step = null;
    this.original_step_copy = null;
  }

  RemoveAppointmentTeamMember(tm: any) {
    this.step.data.allowed_team_members =
      (this.step.data.allowed_team_members || []).filter((m: any) => m.guid !== tm.guid);
    this.CheckAppointmentPermissions();
    this.CheckAppointmentCalendarSetups();
  }

  async presentSelectAppointmentTeamMembers() {
    if (!this.step.data.allowed_team_members) this.step.data.allowed_team_members = [];
    const modal = await this.modalController.create({
      component: TeamMemberSelectPage,
      cssClass: 'small-modal tall-modal secondary-modal',
      backdropDismiss: true,
      componentProps: {
        selecting_for_company: false,
        selecting_for_projects: false,
        selected_team_members: this.step.data.allowed_team_members,
        remove_team_members: this.step.data.allowed_team_members,
        in_team_members: this.project.all_team_members ? [] : this.possible_team_members,
        target_header: 'Currently Selected'
      }
    });
    modal.onDidDismiss().then(() => {
      this.CheckAppointmentPermissions();
      this.CheckAppointmentCalendarSetups();
    });
    return await modal.present();
  }

  OnAnyAppointmentTeamMemberChange() {
    this.appointment_team_members_valid = true;
    this.possible_team_members.forEach((tm: any) => { tm.permission_error = []; });
    if (!this.step.data.any_team_member) {
      if (!this.step.data.allowed_team_members) this.step.data.allowed_team_members = [];
      const currentUser = this.globalService.GetCurrentUser();
      if (currentUser && !(this.step.data.allowed_team_members || []).some((m: any) => m.guid === currentUser.guid)) {
        this.step.data.allowed_team_members = [{ ...currentUser }];
      }
      this.CheckAppointmentPermissions();
    }
    this.CheckAppointmentCalendarSetups();
  }

  async CheckAppointmentCalendarSetups() {
    if (Number(this.step.type) !== stepTypeEnum.appointment_request) {
      this.appointment_calendar_setup_warnings = [];
      return;
    }
    const tms_to_check = this.step.data.any_team_member
      ? this.possible_team_members
      : (this.step.data.allowed_team_members || []);

    const warnings: string[] = [];
    for (const tm of tms_to_check) {
      if (!(tm.guid in this.calendarSetupCache)) {
        const data: any = await this.apiService.get(`calendar/setup/${tm.guid}`);
        this.calendarSetupCache[tm.guid] = data?.success && Array.isArray(data.data) && data.data.length > 0;
      }
      if (!this.calendarSetupCache[tm.guid]) {
        warnings.push(tm.display_name);
      }
    }
    this.appointment_calendar_setup_warnings = warnings;
  }

  async CheckAppointmentPermissions() {
    this.appointment_team_members_valid = true;
    this.possible_team_members.forEach((tm: any) => { tm.permission_error = []; tm.permissionCache = tm.permissionCache || {}; });

    const allClients: any[] = this.project.assigned_clients || [];
    const allCompanies: any[] = this.project.assigned_companies || [];
    if (!allClients.length && !allCompanies.length) return;

    for (const tm of (this.step.data.allowed_team_members || [])) {
      if (tm.is_admin === 1) continue;
      const cache = tm.permissionCache || (tm.permissionCache = {});

      for (const client of allClients) {
        const key = `${client.guid}_false`;
        if (!(key in cache)) {
          const r: any = await this.apiService.get(`team_members/${tm.guid}/permissions/${client.guid}/false`);
          cache[key] = r.success;
        }
        if (!cache[key]) {
          this.appointment_team_members_valid = false;
          tm.permission_error.push(client.display_name || client.name || 'Unknown client');
        }
      }

      for (const company of allCompanies) {
        const key = `${company.guid}_true`;
        if (!(key in cache)) {
          const r: any = await this.apiService.get(`team_members/${tm.guid}/permissions/${company.guid}/true`);
          cache[key] = r.success;
        }
        if (!cache[key]) {
          this.appointment_team_members_valid = false;
          tm.permission_error.push(company.name || 'Unknown company');
        }
      }
    }
  }

  ResetStepForm() {
    this.step = {
      "guid": "",
      "title": "",
      "description": "",
      "type": null,
      "is_internal": this.project.is_internal,
      "company": {},
      "client": {},
      "status": "0",
      "due_date": "",
      "relative_date": true,
      "due_date_relative": 0,
      "auto_start": false,
      "data": {
        webhook_method: 'POST',
        use_cert: true,
        // New actions remind automatically, on the firm's default reminder schedule
        auto_remind: true,
        use_firm_days_between: true,
        // New actions don't start automatically, so emails are reviewed before sending (see AutoStartChange)
        review_before_sending: true,
      }
    };
    this.selected_template = '0';
    this.CalculateDueDate();
    // CalculateDueDate returns early in edit mode, so set the new action's date directly.
    this.CalculateDueDateStep();
  }

  private normalizeSurveys(surveys: any[]): any[] {
    if (!surveys?.length) return surveys;
    return surveys.map(s => Array.isArray(s) ? s[0] ?? null : s).filter(Boolean);
  }

  private normalizeConditionalOptions(options: any[]) {
    for (const option of options) {
      option.label = option.label ?? '';
      option.pre_choice_description = option.pre_choice_description ?? '';
      option.post_choice_instructions = option.post_choice_instructions ?? '';
    }
  }

  private hasRichTextContent(value: string): boolean {
    if (!value) return false;
    const plainText = value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();
    return plainText.length > 0;
  }

  HasTeamMembersWithAllSkills() {
    if (!this.task.skills) return '';
    if (this.task.skills.length == 0) return '';
    let all_team_members = this.possible_team_members;
    if (this.task.assignment_settings == 2 && this.task.assigned_member_guid != '') {
      all_team_members = this.possible_team_members.filter(member => member.guid === this.task.assigned_member_guid);
    }
    for (const member of all_team_members) {
      let has_all_skills = this.task.skills.every(skill =>
        member.skills && member.skills.some(memberSkill => memberSkill.guid === skill.guid)
      );

      if (has_all_skills) {
        return "";
      }
    }
    if (this.task.assignment_settings == 2 && this.task.assigned_member_guid != '') {
      return 'The assigned team member does not have all the required skills.';
    }
    return "No team members have all the required skills.";

  }

  CalculateEstimatedTime() {
    this.task.estimated_hours = Number(this.task.estimated_hours) || 0;
    this.task.estimated_mins = Number(this.task.estimated_mins) || 0;
    this.task.estimated_time = (this.task.estimated_hours * 60) + this.task.estimated_mins;
  }

  //Logic for the better editor UI.
      OnEditorSelectionChanged(event: any) {
    if (event.range !== null) {
      this.lastCursorIndex = event.range.index;
    }
  }

  OnEditorContentChanged(event: any) {
    const range = event.editor?.getSelection();
    if (range !== null) {
      this.lastCursorIndex = range?.index ?? this.lastCursorIndex;
    }
  }

  AppendToStepSubject(field: string) {
    const current = this.step.data.subject || '';
    const prefix = current.length > 0 && current[current.length - 1] !== ' ' ? ' ' : '';
    this.step.data.subject = current + prefix + field + ' ';
  }

  AppendToStepDescription(field: string) {
    const current = this.step.data.description || '';
    const prefix = current.length > 0 && current[current.length - 1] !== ' ' ? ' ' : '';
    this.step.data.description = current + prefix + field + ' ';
  }

  AppendToBody(field: string) {
    const quill = this.bodyEditor?.quillEditor;
    if (quill) {
      const index = this.lastCursorIndex ?? quill.getLength();
      const charBefore = index > 0 ? quill.getText(index - 1, 1) : ' ';
      const charAfter = quill.getText(index, 1);
      const prefix = charBefore !== ' ' ? ' ' : '';
      const suffix = charAfter !== ' ' && charAfter !== '.' && charAfter !== '\n' && charAfter !== '' ? ' ' : '';
      const textToInsert = prefix + field + suffix;
      quill.insertText(index, textToInsert, 'user');
      const newIndex = index + textToInsert.length;
      quill.setSelection(newIndex, 0);
      this.lastCursorIndex = newIndex;
      // Sync ngModel
      this.step.data.body = quill.root.innerHTML;
    } else {
      this.step.data.body = (this.step.data.body || '') + field;
    }
  }

  

}

